/*!
 *
 * app.js
 *
 */
/*** ./modules **/
import menu from './modules/menu';
import widget from './modules/widget';
function init() {
    setTimeout(() => {
        document.documentElement.style.setProperty('--scroll-behavior', 'smooth');
    }, 100);
    new menu({
        button: '#menu-toggle',
        menu: '#menu',
    });
    widget();
    initTop();
    initAccordion();
    initModelSlider();
    initTab();
    initModal();
    initOrderForm();
}
;
async function initAccordion() {
    const elems = document.querySelectorAll('.js-accordion');
    if (elems.length > 0) {
        const { default: accordion } = await import(
        /* webpackChunkName: "accordion" */ './modules/accordion');
        accordion(elems);
    }
}
async function initModelSlider() {
    const elems = document.querySelectorAll('.ws-model-slider');
    if (elems.length > 0) {
        const { default: modelSlider } = await import(
        /* webpackChunkName: "model-slider" */ './modules/model-slider');
        modelSlider(elems);
    }
}
async function initTab() {
    const elems = document.querySelectorAll('.c-tab');
    if (elems.length > 0) {
        const { default: tab } = await import(
        /* webpackChunkName: "tab" */ './modules/tab');
        tab('.c-tab');
    }
}
async function initModal() {
    const elems = document.querySelectorAll('.c-modal-link');
    if (elems.length > 0) {
        const { default: modal } = await import(
        /* webpackChunkName: "modal" */ './modules/modal');
        modal(elems);
    }
}
async function initOrderForm() {
    const elem = document.querySelector('#order-form');
    if (elem) {
        const { default: orderForm } = await import(
        /* webpackChunkName: "order-form" */ './modules/order-form');
        orderForm();
    }
}
async function initTop() {
    const elem = document.querySelector('.top-hero');
    if (elem) {
        const { default: Top } = await import(
        /* webpackChunkName: "top" */ './modules/top');
        Top();
    }
}
document.readyState !== "loading" ? init() : document.addEventListener("DOMContentLoaded", init);
